// extracted by css-extract-rspack-plugin
export default {"dropContent":"drop-content--eaoo0jfblIsJhOPu","foldersContainer":"folders-container--yFOEqCWRgzIrqnFj","newFolderWrapper":"new-folder-wrapper--HXdN46MtcJkUZgxA"};